import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (err) {
      // 401 on first load is expected (not logged in). Log unexpected errors.
      if (err?.response?.status && err.response.status !== 401) {
        console.error("auth/me failed", err);
      }
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchMe();
  }, [fetchMe]);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data.user);
    return data.user;
  }, []);

  const register = useCallback(async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setUser(data.user);
    return data.user;
  }, []);

  const sendPhoneOtp = useCallback(async (phone) => {
    const { data } = await api.post("/auth/phone/send-otp", { phone });
    return data;
  }, []);

  const verifyPhoneOtp = useCallback(async (phone, code, display_name) => {
    const { data } = await api.post("/auth/phone/verify-otp", { phone, code, display_name });
    setUser(data.user);
    return data;
  }, []);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } catch (err) {
      console.error("logout failed", err);
    }
    setUser(false);
  }, []);

  const value = useMemo(
    () => ({ user, loading, login, register, logout, refresh: fetchMe, setUser, sendPhoneOtp, verifyPhoneOtp }),
    [user, loading, login, register, logout, fetchMe, sendPhoneOtp, verifyPhoneOtp],
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
